export const PROJECT_COLORS: readonly string[] = [
  '#4dbd89',
  '#8dc870',
  '#bdd05c',
  '#f8a036',
  '#ff7d2d',
  '#ff5e2f',
  '#ff3c00',
] as const;
